let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("1EBkH")).then(() => parcelRequire('7E8Cc'));